/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ScrollMenu from 'react-horizontal-scrolling-menu';

// import { loadProgressBar } from "axios-progress-bar";
// import queryString from "query-string";

// import ContentItemVod from "../../components/ContentItemVod";
import moment from 'moment';
import ContentItemWide from '../../components/ContentItemWide';
import TagSearchMainSame from './TagSearchMainSame';
import BarBannerItem from '../../components/banner/BarBannerItem';
//import InfiniteScroll from 'react-infinite-scroll-component';
//import PerfectScrollbar from 'react-perfect-scrollbar'

//import TagSameCode from './TagSameCode';
//import TagGenreCode from './TagGenreCode';
//import TagTagCode from './TagTagCode'
//import TagViewCode from './TagViewCode';
//import TagMemberShipCode from './TagMemberShipCode';
//import TagSearchBanner from './TagSearchBanner'

//import TagSearchBox from './TagSearchBox';
//import ThemeRolling from './ThemeRolling'

//import ProgressContainer from '../containers/ProgressContainer'

class TagSearchMain extends Component {
  state = {
    slideIndex: 1,
    slidePlay: true,
    mouseOn: false,
    week: new Date().getDay(),
  };

  componentDidMount = () => {
    this._getData();
    this._getBanner();
  };

  _getData = async () => {
    const curDate = new Date();

    const result = await this._getDateApi(curDate);
    const intReturn = result.data[0].intReturn;
    const updateList = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        updateList,
      });

      if (updateList) {
        setTimeout(() => {
          this._filter();
        }, 500);
      }
    }
  };
  _getDateApi = (curDate) => {
    // const { sameCode } = this.state;
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/updateWeek', {
        params: {
          curDate: moment(curDate).format('YYYY-MM-DD HH:mm:ss'),
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBanner = async () => {
    const result = await this._getBannerApi();
    const intReturn = result.data[0].intReturn;
    const barBannerList = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        barBannerList,
      });
    }
  };
  _getBannerApi = () => {
    const { apiUrl } = this.props;
    //loadProgressBar()

    return axios(apiUrl + '/topBannerBar')
      .then((response) => response)
      .catch((error) => {
        //console.log('error....')
      });
  };
  _filter = () => {
    const { week, updateList } = this.state;

    let weekList = [];
    if (updateList) {
      updateList.filter((item, index) => {
        if (item.ww === week) {
          weekList.push(item);
        }
      });

      this.setState({
        weekList,
      });
    }
  };
  _changeWeek = (week) => {
    this.setState({
      week,
    });

    setTimeout(() => {
      this._filter();
    }, 500);
  };
  _renderItem = () => {
    const { weekList } = this.state;

    const list = weekList.map((item, index) => {
      return (
        <div key={index}>
          <ContentItemWide
            refer={'update'}
            title={item.title}
            subTitle={item.subTitle}
            img={item.img}
            overImg={item.overImg}
            contentSerial={item.contentSerial}
            contentPartSerial={item.contentPartSerial}
            subPartSerial2={item.vodSerial}
            subPartSerial3={item.subPartSerial3}
            lastContentPartSerial={item.lastContentPartSerial}
            pos={item.pos}
            mediaTime={'00:00:00'}
            dRank={item.dRank}
            opening={item.opening}
            part={item.part}
            wishFlag={item.wishFlag}
            num={index + 1}
            onEndItemSlide={this._onEndItemSlide}
          />
        </div>
      );
    });

    return list;
  };
  _renderDot = () => {
    const { slideIndex, weekList } = this.state;
    const cnt = weekList.length;
    let page = Math.round(cnt / 6);
    if (page === 0) {
      page = 1;
    }
    let arr = [];

    for (let i = 1; i <= page; i++) {
      arr.push(<em key={i} className={i === slideIndex ? 'on' : null}></em>);
    }
    const list = arr.map((item) => {
      return item;
    });
    ////console.log()
    return list;
  };
  _timeTable = () => {
    const { setTimelineWeek } = this.props;
    setTimelineWeek(true);
  };
  render() {
    const { weekList, mouseOn, slideIndex, week, barBannerList } = this.state;
    const { allShow } = this.props.childProps;
    const { serviceEndDate } = this.props;
    //console.log(barBannerList ? barBannerList : 'nodata')
    return (
      <Fragment>
        <div className="vod_list_group">
          <TagSearchMainSame allShow={allShow} />
          {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
          serviceEndDate ? null : (
            <>
              <div className="vod_tit">
                <h2>주간 업데이트</h2>
                <div className="tab_menu">
                  <button
                    type="button"
                    className={week === 1 ? 'active' : null}
                    onClick={() => this._changeWeek(1)}
                  >
                    <b>월(月)</b>
                  </button>
                  <button
                    type="button"
                    className={week === 2 ? 'active' : null}
                    onClick={() => this._changeWeek(2)}
                  >
                    <b>화(火)</b>
                  </button>
                  <button
                    type="button"
                    className={week === 3 ? 'active' : null}
                    onClick={() => this._changeWeek(3)}
                  >
                    <b>수(水)</b>
                  </button>
                  <button
                    type="button"
                    className={week === 4 ? 'active' : null}
                    onClick={() => this._changeWeek(4)}
                  >
                    <b>목(木)</b>
                  </button>
                  <button
                    type="button"
                    className={week === 5 ? 'active' : null}
                    onClick={() => this._changeWeek(5)}
                  >
                    <b>금(金)</b>
                  </button>
                  <button
                    type="button"
                    className={week === 6 ? 'active' : null}
                    onClick={() => this._changeWeek(6)}
                  >
                    <b>토(土)</b>
                  </button>
                  <button
                    type="button"
                    className={week === 7 ? 'active' : null}
                    onClick={() => this._changeWeek(7)}
                  >
                    <b>일(日)</b>
                  </button>
                </div>
              </div>
              {weekList ? (
                <div className="main_list_style">
                  <div
                    className="main_list_goup1"
                    style={{ width: '100%' }}
                    onMouseEnter={this._onToggleMouseOn}
                    onMouseLeave={this._onToggleMouseOff}
                  >
                    <div className="div_ul">
                      <ScrollMenu
                        data={weekList ? this._renderItem() : null}
                        arrowLeft={
                          mouseOn ? (
                            slideIndex === 1 ? null : (
                              <a
                                className="left_btn"
                                style={{ cursor: 'pointer' }}
                                onClick={this._arrowPrev}
                              >
                                <span className={'on'}>이전</span>
                              </a>
                            )
                          ) : null
                        }
                        arrowRight={
                          mouseOn ? (
                            slideIndex >=
                            parseInt(weekList.length / 6) ? null : (
                              <a
                                className="right_btn"
                                style={{ cursor: 'pointer' }}
                                onClick={this._arrowNext}
                              >
                                <span className={'on'}>다음</span>
                              </a>
                            )
                          ) : null
                        }
                        wheel={false}
                        dragging={true}
                        transition={0.5}
                        translate={2}
                        alignOnResize={true}
                        //inertiaScrolling={true}
                        //inertiaScrollingSlowdown={3}
                        //wrapperStyle={{border: 0, backgroundColor: '#000'}}
                        alignCenter={false}
                        hideSingleArrow={true}
                        hideArrows={mouseOn}
                        onUpdate={(t) => {}}
                        ref={(ref) => (this.scrollMenu = ref)}
                        scrollBy={6}
                        //innerWrapperStyle={{textAlign: 'center'}}
                        //onSelect={this._onSelect}
                        //selected={selected}
                      />
                      {/*
                                    <div className="div_li">
                                        <em><img src="img/top10.png"/></em>
                                        <div className="list_img_bg"><img src="img/test_img5.png"/></div>
                                        <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                                    </div>
                                    <div className="div_li">
                                        <div className="list_img_bg"><img src="img/test_img5.png"/></div>
                                        <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                                    </div>
                                    */}
                    </div>

                    <div className="clear"></div>
                  </div>
                </div>
              ) : (
                <div className="main_list_style">
                  <div className="main_list_goup1" style={{ width: '100%' }}>
                    <div className="div_ul">
                      <div className="div_li">
                        <div className="list_img_bg"></div>
                        <p>방송직후 업데이트 됩니다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {barBannerList ? (
            barBannerList[0] ? (
              <div className="live_top_baner" style={{ zIndex: 1000 }}>
                <BarBannerItem
                  index={1}
                  bannerFile={barBannerList[0].bannerFile}
                  bannerFile_s={barBannerList[0].bannerFile_s}
                  LinkURL={barBannerList[0].LinkURL}
                  Linktarget={barBannerList[0].Linktarget}
                  LinkURL_M={barBannerList[0].LinkURL_M}
                  Linktarget_M={barBannerList[0].Linktarget_M}
                  idx={barBannerList[0].idx}
                  comment={barBannerList[0].comment}
                  adComIdx={barBannerList[0].adComIdx}
                  pageCode={barBannerList[0].pageCode}
                />
              </div>
            ) : null
          ) : null}
        </div>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(TagSearchMain));
